var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inline)?_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}):_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"fixed-width":""}})}
var staticRenderFns = []

export { render, staticRenderFns }